module.exports = __webpack_public_path__ + "static/img/dg.5af50607.svg";